// partner 경로인 경우 실행되어 usePartnerStore()에 파트너 정보를 세팅하는 컴포저블
export const usePartnerLoader = async (partnerPath?: string) => {
  const route = useRoute()
  const partnerStore = usePartnerStore()
  const partnerDomain = partnerPath ? partnerPath : (route.params.partner as string)

  // 이미 로드된 파트너 정보가 있는 경우, 중복 요청 방지
  if (!partnerDomain || partnerStore.partnersKey === partnerDomain) {
    return
  }
  partnerStore.setPartnersKey(partnerDomain)

  const { getPartnersInfo } = useApi()
  const { data: response, error } = await useAsyncData(
    `partner-${partnerDomain}`,
    () => getPartnersInfo(partnerDomain) as Promise<ApiRes<Partner>>
  )

  if (error.value || !response.value?.success || !response.value.data) {
    alert('채널 정보가 없습니다.')
    navigateTo('/')
    return
  }

  partnerStore.setPartner(response.value.data)
}
